import { AuthToken, TokenManagerType } from './type'
import axios from '../../config/connections'
import { AxiosResponse } from 'axios'

const TOKEN_LOCATION = 'token'
const REFRESH_TOKEN_LOCATION = 'refresh_token'
const EXPIRE_DATE_LOCATION = 'token_expire_date'

const TokenManager = (): TokenManagerType => {
  let isRefreshing = null

  const getToken = (): string => {
    return localStorage.getItem(TOKEN_LOCATION)
  }

  const getRefreshToken = (): string => localStorage.getItem(REFRESH_TOKEN_LOCATION)

  const getTokenExpireDate = (): string => localStorage.getItem(EXPIRE_DATE_LOCATION)

  const setToken = (token: AuthToken): void => {
    localStorage.setItem(TOKEN_LOCATION, token.access_token)
    localStorage.setItem(REFRESH_TOKEN_LOCATION, token.refresh_token)
    localStorage.setItem(EXPIRE_DATE_LOCATION, token.expire_at)
  }

  const isTokenExpired = (): boolean => {
    const tokenExpireDate = getTokenExpireDate()
    // Refresh token 1 minute before it was actually expired
    const tokenExpireOn = Number(new Date(tokenExpireDate)) - 60 * 1000
    const currentTime = Number(new Date())
    return currentTime > tokenExpireOn
  }

  const removeToken = (): void => {
    localStorage.removeItem(TOKEN_LOCATION)
    localStorage.removeItem(REFRESH_TOKEN_LOCATION)
    localStorage.removeItem(EXPIRE_DATE_LOCATION)
  }
  const getRefreshStatus = (): null | Promise<AxiosResponse> => {
    return isRefreshing
  }

  const refreshToken = async (payload: { refresh_token: string }): Promise<AxiosResponse> => {
    isRefreshing = axios.post('/auth/refresh', payload).catch(function () {
      removeToken()
    })
    const response = await isRefreshing
    setToken(response.data.result)
    return response
  }

  const waitForTokenRefresh = async (): Promise<void> => {
    if (!isRefreshing) return
    await isRefreshing
    isRefreshing = null
    return
  }

  const validateToken = async (): Promise<void> => {
    const tokenExpired = isTokenExpired()
    const isRefreshing = getRefreshStatus()
    const refreshTk = getRefreshToken()
    if (refreshTk != null && tokenExpired && !isRefreshing) {
      await refreshToken({ refresh_token: refreshTk })
    }
    await waitForTokenRefresh()
  }

  return {
    getToken,
    getRefreshToken,
    setToken,
    removeToken,
    refreshToken,
    isTokenExpired,
    waitForTokenRefresh,
    validateToken,
  }
}

export default TokenManager()
